<div class="floating-input-container">
  <div class="input-wrapper" (click)="onContainerClick()">
    @if (label) {
    <label
      [class]="isFloating() ? 'label-floating' : 'label'"
      [attr.for]="'input-' + label"
    >
      {{ label }}
    </label>
    }

    <!-- Left icon slot -->
    @if (leftIconTemplate) {
      <ng-container [ngTemplateOutlet]="leftIconTemplate"></ng-container>
    } @else if (showDefaultLeftIcon()) {
      @switch (getDefaultLeftIconType()) {
        @case ('mail') {
          <app-mail-icon width="16" height="16" fill="#26A2F1" />
        }
        @case ('key') {
          <app-key-icon width="16" height="16" fill="#26A2F1" />
        }
      }
    }

    <!-- Input element -->
    <input
      #inputElement
      [id]="'input-' + label"
      [type]="currentInputType()"
      class="input-field"
      [value]="_value()"
      [disabled]="disabled"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [attr.aria-label]="label"
      [attr.aria-describedby]="label ? 'label-' + label : null"
    />

    <!-- Right icon slot -->
    @if (rightIconTemplate) {
      <ng-container [ngTemplateOutlet]="rightIconTemplate"></ng-container>
    } @else if (showDefaultRightIcon()) {
      <button
        type="button"
        class="password-toggle"
        (click)="togglePasswordVisibility($event)"
        [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <g clip-path="url(#clip0_4308_4850)">
            <path d="M7.99062 4.71547C10.5173 4.71547 12.7706 6.13547 13.8706 8.38214C12.7706 10.6288 10.524 12.0488 7.99062 12.0488C5.45729 12.0488 3.21062 10.6288 2.11062 8.38214C3.21062 6.13547 5.46395 4.71547 7.99062 4.71547ZM7.99062 3.38214C4.65729 3.38214 1.81062 5.45547 0.657288 8.38214C1.81062 11.3088 4.65729 13.3821 7.99062 13.3821C11.324 13.3821 14.1706 11.3088 15.324 8.38214C14.1706 5.45547 11.324 3.38214 7.99062 3.38214ZM7.99062 6.71547C8.91062 6.71547 9.65729 7.46214 9.65729 8.38214C9.65729 9.30214 8.91062 10.0488 7.99062 10.0488C7.07062 10.0488 6.32395 9.30214 6.32395 8.38214C6.32395 7.46214 7.07062 6.71547 7.99062 6.71547ZM7.99062 5.38214C6.33729 5.38214 4.99062 6.72881 4.99062 8.38214C4.99062 10.0355 6.33729 11.3821 7.99062 11.3821C9.64395 11.3821 10.9906 10.0355 10.9906 8.38214C10.9906 6.72881 9.64395 5.38214 7.99062 5.38214Z" fill="#0C6AA8"/>
          </g>
          <defs>
            <clipPath id="clip0_4308_4850">
              <rect width="16" height="16" fill="white" transform="translate(-0.00939941 0.382141)"/>
            </clipPath>
          </defs>
        </svg>
      </button>
    }
  </div>
  
  @if (error) {
    <div class="error-message">
      {{ error }}
    </div>
  }
</div>